import React, { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './SpaceCalculator.css';
// import jsPDF from 'jspdf';
import CalculatorReview from '../../components/CalculatorReview';
import { useSelector } from 'react-redux';
import { fetchAnimalTypeByCategoryId, fetchCalculatorReviewByReviewType, fetchSpaceCategoryByAnimalTypeId, spaceCalculation } from '../../action/functions';
import ButtonFrame from '../../snippets/ButtonFrame';
import ToastMessage from '../../snippets/ToastMessage';
import SignInModal from '../../snippets/modal/SignInModal';
import SignUpModal from '../../snippets/modal/SignUpModal';
import useGoogleAnalytics from '../../action/useGoogleAnalytics';


const SpaceCalculator = () => {
  const trackEvent = useGoogleAnalytics("G-JKWGJ86LX7");

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    animal_type : '0',
    space_category : '0',
    unit_type : 1,
    max_age : 1,
    space_type: 2,
    dimensions: {
      w1: '',
      l1: '',
      w2: '',
      l2: ''
    }
  })

  const [msgAlert, setMsgAlert] = useState({
    active: false,
    message: "",
    status: "warning"
  });
  const [unit, setUnit] = useState('sqft');

  // const isSquare = formData.dimensions.w1 === formData.dimensions.w2 && formData.dimensions.l1 === formData.dimensions.l2;
  // const isRectangle = formData.dimensions.w1 === formData.dimensions.w2 && formData.dimensions.l1 !== formData.dimensions.l2;

  // const isTrapezium = formData.dimensions.w1 !== formData.dimensions.w2;
  // const isParallelogram = formData.dimensions.l1 === formData.dimensions.l2 && formData.dimensions.w1 !== formData.dimensions.w2; 



  // const getPolygonPoints = () => {
  //   if (isTrapezium) {
  //     const offset = Math.abs(formData.dimensions.w2 - formData.dimensions.w1) / 2;
  //     return `${offset},0 
  //             ${formData.dimensions.w1 + offset},0 
  //             ${formData.dimensions.w2},${formData.dimensions.l1} 
  //             0,${formData.dimensions.l2}`;
  //   }
  //   return `0,0 
  //           ${formData.dimensions.w1},0 
  //           ${formData.dimensions.w2},${formData.dimensions.l1} 
  //           0,${formData.dimensions.l2}`;
  // };

  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);

  const [animalType, setAnimalType] = useState(null);
  const [breedType, setBreedType] = useState([
    {
      id: "0",
      name: "Select Breed Category"
    }
  ]);
  const [typeCat, setTypeCat] = useState([
    {
      value: "",
      name: "Select Age"
    }
  ]);
  const [hasReviewed, setHasReviewed] = useState(false);

  const [spaceData, setSpaceData] = useState(null);

  const [activeTab, setActiveTab] = useState('space');

  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);

  const account = useSelector(state => state.account);

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_title: "Egg Calculator",
        page_location: window.location.href,
        page_path: "/space-calculator", 
      });
    }
  }, []);

  useEffect(() => {
    if (animalType) return;
    (async() => {
      let result = await fetchAnimalTypeByCategoryId(1);

      if (!result.status) {
        setMsgAlert({
          active: true,
          message: result.message,
          status: "error"
        });
        return;
      }
      setAnimalType([{
        id: "0",
        name: "Select Poultry Type",
        selected: true
      }, ...result.data.data]);

    })();
  }, [animalType]);

  useEffect(() => {
    if (!account || !account.isAuthenticated) return;

    (async() => {
      let result = await fetchCalculatorReviewByReviewType(account.token, 1);

      if (!result.status) {
        setMsgAlert({
          active: true,
          message: result.message,
          status: "error"
        });
        return;
      }

      if (result.data.data.review.length > 0) {
        setHasReviewed(true);
      }else {
        setHasReviewed(false);
      }

    })();
  }, [account]);

  useEffect(() => {
      if (activeTab === 'space-result') {
        const timer = setTimeout(() => {
          if (hasReviewed) return;
          setIsRatingModalOpen(true);
        }, 30000); 
  
        return () => clearTimeout(timer);
      }
  }, [activeTab, hasReviewed]);
  
  const closeRatingModal = () => {
    setIsRatingModalOpen(false);
  }

  const handleFormChange = (evt, name) => {
    setFormData({...formData, [name]:evt.target.value});
  }

  const handleArrayChange = (name, new_value) => {
    setFormData({...formData, [name]:new_value});
  }

  const handleAnimalChange = async (evt) => {
    handleFormChange(evt, 'animal_type');
    let result = await fetchSpaceCategoryByAnimalTypeId(evt.target.value);
    if (!result.status) {
      setMsgAlert({
        active: true,
        message: result.message,
        status: "error"
      });
      return;
    }

    setBreedType([
      {
        id: "0",
        name: "Select Breed Category"
      },
      ...result.data.data
    ]);
  }

  const handleBreedChange = (evt) => {
    handleFormChange(evt, 'space_category');

    if (evt.target.value === "0") {
      setTypeCat([
        {
          value: "",
          name: "Select Age"
        }
      ])
      return;
    }
    
    let selected_item_qs = breedType.filter((item) => parseInt(item.id) === parseInt(evt.target.value));

    if (!selected_item_qs.length) return;
    const selected_item = selected_item_qs[0];

    if (selected_item.metadata && selected_item.metadata.drop_data) {
      setTypeCat([
        {
          value: "",
          name: "Select Age"
        },
        ...selected_item.metadata.drop_data
      ])
    }else {
      setTypeCat([
        {
          value: "",
          name: "Select Age"
        }
      ])
    }
  }

  const openSignInModal = () => {
    setIsSignInModalOpen(true);
    setIsSignupModalOpen(false);
  };

  const closeSignInModal = () => {
    setIsSignInModalOpen(false);
  };

  const openSignupModal = () => {
    setIsSignInModalOpen(false);
    setIsSignupModalOpen(true);
  };

  const closeSignupModal = () => {
    setIsSignupModalOpen(false);
  };

  const calculateSpace = async () => {
    if (!account || !account.isAuthenticated) return;

    if (formData.animal_type === "0") {
      setMsgAlert({
        active: true,
        message: 'Poultry type is required',
        status: "warning"
      });
      return null;
    }

    if (formData.space_category === "0") {

      setMsgAlert({
        active: true,
        message: 'Breed category is required',
        status: "warning"
      });
      return null;
    }

    setLoading(true);
    let result = await spaceCalculation(account.token, formData);

    if (result.status) {
      setSpaceData(result.data.data);
      setActiveTab('space-result');
      trackEvent("space_calculator_button");
    }else {
      setMsgAlert({
        active: true,
        message: result.message,
        status: "error"
      });
    }
    setLoading(false);
  };

  const handleBack = () => {
    setActiveTab('space');
  };

  const getFormattedDate = () => {
    const today = new Date();
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return today.toLocaleDateString('en-GB', options).replace(',', '.');
  };

  // const downloadAsPDF = async () => {
  //   const feedWatermark = document.querySelector('.watermark-image');
  //   const feedResultHeader = document.querySelector('.feed-result-header');
  //   const feedResultLogoHeader = document.querySelector('.feed-result-logo-header');
  //   const feedActionsBtn = document.querySelector('.feed-actions');
  //   const fetchSocial = document.querySelector('.feed-result-social-container');
  //   const fetchEdit = document.querySelector('.space-edit-button');

  //   if (feedResultHeader && feedResultLogoHeader && (account && account.isAuthenticated)) {

  //     feedResultHeader.style.display = 'none';
  //     feedActionsBtn.style.display = 'none';
  //     fetchEdit.style.display = 'none';
  //     feedResultLogoHeader.style.display = 'flex';
  //     fetchSocial.style.display = 'flex';
  //     feedWatermark.style.display = 'flex';

  //     await html2canvas(document.querySelector('.space-result-container'), { scale: 2 }).then((canvas) => {
  //       const imgData = canvas.toDataURL('image/png');
  //       const imgWidth = 210; 
  //       const pageHeight = 297;
  //       const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //       const pdf = new jsPDF('p', 'mm', 'a4');
  //       let yPosition = 10;

  //       if (imgHeight <= pageHeight) {
  //         pdf.addImage(imgData, 'PNG', 0, yPosition, imgWidth, imgHeight);
  //       } else {
  //         let remainingHeight = imgHeight;
  //         let srcY = 0; 

  //         while (remainingHeight > 0) {
  //           const cropHeight = Math.min(remainingHeight, pageHeight - 10);
  //           const croppedCanvas = document.createElement('canvas');
  //           croppedCanvas.width = canvas.width;
  //           croppedCanvas.height = (cropHeight * canvas.width) / imgWidth;

  //           const croppedCtx = croppedCanvas.getContext('2d');
  //           croppedCtx.drawImage(
  //             canvas,
  //             0,
  //             srcY,
  //             canvas.width,
  //             croppedCanvas.height,
  //             0,
  //             0,
  //             croppedCanvas.width,
  //             croppedCanvas.height
  //           );

  //           const croppedImg = croppedCanvas.toDataURL('image/png');
  //           pdf.addImage(croppedImg, 'PNG', 0, yPosition, imgWidth, cropHeight);

  //           remainingHeight -= cropHeight;
  //           srcY += croppedCanvas.height;

  //           if (remainingHeight > 0) {
  //             pdf.addPage();
  //           }
  //         }
  //       }

  //       pdf.save(`Feed result_${getFormattedDate()}_${account.fullname.split(" ")[0]}.pdf`);

  //       feedResultHeader.style.display = 'flex';
  //       feedActionsBtn.style.display = 'flex';
  //       fetchEdit.style.display = 'flex';
  //       feedResultLogoHeader.style.display = 'none';
  //       fetchSocial.style.display = 'none';
  //       feedWatermark.style.display = 'none';
  //     });
  //   }
  // };

  useEffect(() => {
    if (activeTab === "space-result") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [activeTab]);

  return (
    <>
      <Navbar/>
      {(!account || !account.isAuthenticated) && (
        <div className='email-popup-container'>
          <div className='check-email-popup'>
            <div className='email-popup-header'>
              <img src="/assets/carbon_email.svg" alt="Email Icon" className='email-popup-icon'/>
              <p className='email-popup-text'>Sign in / Sign up to use calculator</p>
            </div>
          </div>        
        </div>
      )}

      <div className="feed-calculator-container">
        <div className={`feed-calculator-header-container ${activeTab === 'space-result' ? 'hidden' : ''}`}>
            <div className="feed-calculator-header">
              <img src="/assets/space-title-image.svg" alt="pond_trees"/>
              <h1>My Space Calculator</h1>
            </div>
            <p className='feed-header-desc-mobile'>My Space Calculator helps you determine how many poultry birds can fit in your coop area, hen house or factory housing.</p>

            <div className='feed-calculator-tabs-container'>
              <p>My Space Calculator helps you determine how many poultry birds can fit in your coop area, hen house or factory housing.</p>
            </div>
        </div>


        <div className='feed-calculator-result'>
            {activeTab === 'space' && (
              <div className="feed-calculator-card">

              {/* Poultry Type */}
              <div className="feed-input-container">
                  <select
                    id="poultry-type"
                    value={formData.animal_type}
                    onChange={(e) => handleAnimalChange(e)}
                  >
                    {animalType && animalType.map((type) => (
                      <option key={type.id} value={type.id}>{type.name}</option>  
                    ))}
                  </select>
                  <img src='/assets/dropdown_arrow.png' alt="drop down arrow" />
              </div>

              {/* Breed Category */}
              <div className="feed-input-container">
                  <select
                    id="breed-category"
                    value={formData.space_category}
                    onChange={(e) => handleBreedChange(e)}
                  >
                    {breedType && breedType.map((type) => (
                      <option key={type.id} value={type.id}>{type.name}</option>  
                    ))}
                  </select>
                  <img src='/assets/dropdown_arrow.png' alt="dropdown arrow"/>
              </div>

              {/* Maximum Age */}
              <div className="feed-input-container">
                  <select
                    id="max-age"
                    value={formData.max_age}
                    onChange={(e) => handleFormChange(e, 'max_age')}
                  >
                    {typeCat && typeCat.map((type, index) => (
                      <option key={index} value={type.value}>{type.name}</option>  
                    ))}
                  </select>
                  <img src='/assets/dropdown_arrow.png' alt="dropdown arrow"/>
              </div>

              {/* <div className="calculator-mySpace">
                <div className="custom-rectangle">
                  <div className='label-top'>
                    <span className="label">W2</span>
                    <span className="label-value">{formData.dimensions.w2} ft</span>  
                  </div>
                  <div className='label-bottom'>
                    <span className="label-value">{formData.dimensions.w1} ft</span>
                    <span className="label">W1</span>
                  </div>
                  <div className='label-left'>
                    <span className="label">L1</span>
                    <span className="label-value">{formData.dimensions.l1} ft</span>
                  </div>

                  <div className='label-right'>
                    <span className="label-value">{formData.dimensions.l2} ft</span>
                    <span className="label">L2</span>
                  </div>
                  <div className='floor-diagram'>
                    <svg
                      width={Math.max(formData.dimensions.w1, formData.dimensions.w2)}
                      height={Math.max(formData.dimensions.l1, formData.dimensions.l2)}
                    >
                      <polygon
                        points={getPolygonPoints()}
                        fill="none"
                        stroke="#C8CEDA"
                        strokeWidth="2"
                        strokeDasharray="5,5"
                      />
                    </svg>
                  </div>
                    <div className="center-label">Floor Space</div>
                </div>
              </div> */}
                <div className="unit-selector">
                  <button
                      className={unit === 'sqft' ? 'active' : ''}
                      onClick={() => {
                        setUnit('sqft');
                        setFormData({...formData, unit_type:1});
                      }}
                  >
                      Sq ft
                  </button>
                  <button
                      className={unit === 'sqm' ? 'active' : ''}
                      onClick={() => {
                        setUnit('sqm')
                        setFormData({...formData, unit_type:2});
                      }}
                  >
                      Sq m
                  </button>
                </div>

              {/*W1 and L1*/}
              <div className='feed-input-container'>
                <label>Enter your floor space measurement</label>
              </div>
              <div className="feed-inputs-container">
                  <div className="feed-input-container">
                    <div className='feed-label-wrapper'>
                      <label>Width</label>
                    </div>
                    <div className="feed-input-wrapper">
                      <input
                        type="number"
                        id="space-width"
                        // min={1}
                        placeholder="1"
                        value={formData.dimensions.w1 || ""}
                        onFocus={(e) => e.target.placeholder = ""}
                        onBlur={(e) => e.target.placeholder = "Enter width"}  
                        onChange={(e) => {
                          const newWidth = e.target.value;
                          handleArrayChange("dimensions", { 
                            ...formData.dimensions, 
                            w1: newWidth, 
                            w2: newWidth
                          });
                        }}
                        required
                      />
                      <span className="feed-unit">{unit === 'sqft' ? 'ft' : 'm'}</span>
                    </div>
                  </div>

                  <div className="feed-input-container">
                    <div className='feed-label-wrapper'>
                      <label>Length</label>
                    </div>
                    <div className="feed-input-wrapper">
                      <input
                        type="number"
                        id="end-date"
                        // min={1}
                        placeholder="1"
                        value={formData.dimensions.l1 || ""}
                        onFocus={(e) => e.target.placeholder = ""}
                        onBlur={(e) => e.target.placeholder = "Enter length"}
                        onChange={(e) => {
                          const newLength = e.target.value;
                          handleArrayChange("dimensions", { 
                            ...formData.dimensions, 
                            l1: newLength, 
                            l2: newLength 
                          });
                        }}
                        required
                      />
                      <span className="feed-unit">{unit === 'sqft' ? 'ft' : 'm'}</span>
                    </div>
                  </div>
              </div>

              {/*W2 and L2*/}
              {/* <div className="feed-inputs-container">
                  <div className="feed-input-container">
                    <div className='feed-label-wrapper'>
                      <label>Width (W2)</label>
                    </div>
                    <div className="feed-input-wrapper">
                      <input
                        type="number"
                        id="space-width"
                        min={1}
                        value={formData.dimensions.w2}
                        onChange={(e) => handleArrayChange("dimensions", {...formData.dimensions, w2:e.target.value})}
                        required
                      />
                      <span className="feed-unit">ft</span>
                    </div>
                  </div>

                  <div className="feed-input-container">
                    <div className='feed-label-wrapper'>
                      <label>Length (L2)</label>
                    </div>
                    <div className="feed-input-wrapper">
                      <input
                        type="number"
                        id="end-date"
                        min={1} 
                        value={formData.dimensions.l2}
                        onChange={(e) => handleArrayChange("dimensions", {...formData.dimensions, l2:e.target.value})}
                        required
                      />
                      <span className="feed-unit">ft</span>
                    </div>
                  </div>
              </div> */}
              {account && account.isAuthenticated ? (
                <ButtonFrame handleClick={calculateSpace} loading={loading} btnText={"Calculate"} classNameStyle="space-calculate-btn" />
              ): (
                <ButtonFrame handleClick={() => openSignInModal()} loading={loading} btnText={"Login to access calculator"} classNameStyle="space-calculate-btn" />
              )}
              </div>
            )}

            {spaceData && activeTab === 'space-result' && (
              <div className="space-result-container">
                <header className="feed-result-header">
                  <img src="/assets/next-icon-blue.svg" alt="next arrow" className="feed-back-button" onClick={handleBack}/>
                  <h1>My Space Result</h1>
                  <img src="/assets/send_icon.svg" alt="send icon" className="feed-send-button"/>
                </header>

                <header className="feed-result-logo-header">
                  <img src="/assets/rairer-logo.svg" alt="raier logo" className="feed-result-logo"/>
                  <div className='feed-date-container'>
                    <h4>My Space</h4>
                    <p>{getFormattedDate()}</p>
                  </div>
                </header>

                {/* Chicken Details */}
                <div className="space-bird-card">
                  <div className="feed-card-header">
                    <div className='feed-icon-wrapper-container'>
                      <div className="feed-icon-wrapper">
                        <img src="/assets/myspace-icon.svg" alt="space icon" />
                      </div>
                      <h2>My Space</h2>
                    </div>
                    <button className="space-edit-button" onClick={handleBack}>Edit</button>
                  </div>
                  {/* <div className='feed-card-divider'></div> */}

                  <div className="space-card-body">
                    <div className='feed-info-container'>
                      <img src="/assets/space-chicken-icon.svg" alt="chicken" className='feed-info-img'/>
                      <div className="feed-info">
                        <span className="feed-info-label">Poultry Type</span>
                        <p>{spaceData.space.poultry}</p>
                      </div>
                    </div>
                    <div className='feed-info-container'>
                      <img src="/assets/feather_small.svg" alt="feather" className='feed-info-img'/>
                      <div className="feed-info">
                        <span className="feed-info-label">Breed Type</span>
                        <p>{spaceData.space.breed}</p>
                      </div>
                    </div>
                  </div>

                  <div className="space-card-body" style={{marginTop: '31px'}}>
                    <div className='feed-info-container'>
                      <img src="/assets/rearing-duration.png" alt="rearing icon" className='feed-info-img'/>
                      <div className="feed-info">
                        <span className="feed-info-label">Maximum Age</span>
                        <p>{spaceData.space.age} week(s)</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Floor Space Estimate */}
                <div className="feed-card feed-estimate-card">
                  <div className="feed-title-header">
                    <img src="/assets/floor-estimate.svg" alt="Floor Icon"/>
                    <h2>Floor Space Estimate</h2>
                  </div>

                  <div className='feed-card-divider'></div>
                  <div className="feed-estimate-body">
                    <div className='space-item-container'>
                      <p className='space-item-title'>{`${parseFloat(spaceData.animal_per_space.floor_space.total_floor_aminal).toLocaleString()}`} Birds</p>
                      <p className="feed-duration spanned">Minimum of <span style={{color: '#3EC182'}}>{spaceData.animal_per_space.floor_space.min_space} {spaceData.space.measure_unit}</span> per bird</p>
                    </div>

                    <div>
                      <div className='feed-card-divider'></div>

                      <p className="feed-duration"><span style={{color: '#000000'}}><strong>Note:</strong></span> Estimates are based on the requirements for an ideal housing structure and ventilation mechanism.</p>
                    </div>

                    {/* <div className="calculator-result-mySpace">
                      <div className="custom-rectangle-result">
                        <div className='label-top-result'>
                          <span className="label-value-result">{formData.dimensions.w2} ft</span>  
                        </div>

                        <div className='label-bottom-result'>
                          <span className="label-value-result">{formData.dimensions.w1} ft</span>
                        </div>

                        <div className='label-left-result'>
                          <span className="label-value-result">{formData.dimensions.l1} ft</span>
                        </div>

                        <div className='label-right-result'>
                          <span className="label-value-result">{formData.dimensions.l2} ft</span>
                        </div>

                        <div className='floor-diagram'>
                          <svg
                            width={Math.max(formData.dimensions.w1, formData.dimensions.w2)}
                            height={Math.max(formData.dimensions.l1, formData.dimensions.l2)}
                          >
                            <polygon
                              points={getPolygonPoints()}
                              fill="none"
                              stroke="#3EC182"
                              strokeWidth="2"
                              strokeDasharray="5,5"
                            />
                          </svg>
                        </div>

                        <div className="center-label">Floor Space</div>
                      </div>
                    </div> */}

                  </div>

                  <img src='/assets/rairer-calculator-watermark.svg' alt="watermark" className='watermark-image'/>

                </div>

                {/* Cage Space Estimate */}
                {spaceData.animal_per_space.cage_space && (
                  <div className="feed-card feed-estimate-card">
                    <div className="feed-title-header">
                      <img src="/assets/cage-estimate.svg" alt="Floor Icon"/>
                      <h2>Cage Space Estimate</h2>
                    </div>
                    <div className='feed-card-divider'></div>
                    <div className="feed-estimate-body">
                      <div className='space-item-container'>
                        <p className='space-item-title'>{`${parseFloat(spaceData.animal_per_space.cage_space.total_cage_animal).toLocaleString()}`} Birds</p>
                        <p className="feed-duration spanned">Minimum of <span style={{color: '#3EC182'}}>{spaceData.animal_per_space.cage_space.min_space} {spaceData.space.measure_unit}</span> per bird</p>
                      </div>
                    </div>
                  </div>
                )}

                {/* Running Space Estimate */}
                {spaceData.animal_per_space.run_space && (
                  <div className="feed-card feed-estimate-card">
                    <div className="feed-title-header">
                      <img src="/assets/cage-estimate.svg" alt="Floor Icon"/>
                      <h2>Run Space Estimate</h2>
                    </div>
                    <div className='feed-card-divider'></div>
                    <div className="feed-estimate-body">
                      <div className='space-item-container'>
                        <p className='space-item-title'>{`${parseFloat(spaceData.animal_per_space.run_space.total_run_animal).toLocaleString()}`} Birds</p>
                        <p className="feed-duration spanned">Minimum of <span style={{color: '#3EC182'}}>{spaceData.animal_per_space.run_space.min_space} {spaceData.space.measure_unit}</span> per bird</p>
                      </div>
                    </div>
                  </div>
                )}
                

                <div className='feed-result-social-container'>
                  <p>@rairerapp</p>
                  <div className='feed-social-container'>
                    <img src='/assets/facebook-color.svg' alt='Facebook Icon'/>
                    <img src='/assets/twitter-color.svg' alt='Twitter Icon'/>
                    <img src='/assets/instagram-color.svg' alt='Instagram Icon'/>
                    <img src='/assets/linkedin-color.svg' alt='LinkedIn Icon'/>
                  </div>
                </div>

                {/* Download btn */}
                {/* <div className='feed-actions' onClick={downloadAsPDF}>
                  <div className='feed-action-btn-container'>
                    <img src="/assets/download-outline.png" alt="download icon"/>
                    <button className="feed-action-button" onClick={downloadAsPDF}>Download</button>
                  </div>
                </div> */}
              </div>
            )}
        </div>
        
      </div>
      <Footer/>
      {(account && account.isAuthenticated) && isRatingModalOpen && (
        <CalculatorReview account={account} reviewType={{
          id: 1,
          name: "Space"
        }} closeRatingModal={closeRatingModal}/>
      )}

      {isSignInModalOpen && (
        <SignInModal closeSignIn={closeSignInModal} openSignUp={openSignupModal} onSubmit={closeSignInModal}  />
      )}

      {isSignupModalOpen && (
        <SignUpModal closeSignup={closeSignupModal} openSignIn={openSignInModal} onSubmit={closeSignupModal} />
      )}

      {msgAlert.active && <ToastMessage toastTitle={"Space Calculator"} toastMessage={msgAlert.message} toastType={msgAlert.status} closeOut={() => setMsgAlert({...msgAlert, active:false})} />}
    </>
  );
};

export default SpaceCalculator;
